import gql from 'graphql-tag';

export const QUERY_JOBS_DETAILS = gql`
  query JobsDetails($slug: String!) {
    jobs(where: { slug: $slug }, limit: 1) {
      title_en
      title_de
      description_en
      description_de
      type
      slug
      start_date
      city {
        name_en
        name_de
        country {
          name_en
          name_de
        }
      }
    }
  }
`;
